import loader from '../moduleLoader.js';
import Icon from '../../helpers/iconHelper.js';

function Filter(form) {
    let resultContainer;
    let textFieldTimer;
    const request = new XMLHttpRequest();

    function init() {
        //Fix for prefilled options if set in Edit
        if (form.getAttribute('data-prefilldata')) {
            history.replaceState(null, null, `?${form.getAttribute('data-prefilldata')}`);
        }

        resultContainer = document.getElementById(form.getAttribute('data-filter-for'));
        if (resultContainer) {
            resultContainer.setAttribute('aria-live', 'polite');
        }
        const inputs = form.querySelectorAll('input');
        initFilterInputs(inputs);
        updateFilterInputs(inputs);
        window.addEventListener('popstate', () => {
            var searchParams = new URLSearchParams(location.search)
            fetchFilteredView(searchParams);
            updateFilterInputs(inputs);
        });
        form.addEventListener('submit', (e) => {
            e.preventDefault();
            resultContainer.querySelector('a').focus();
        });
        const clearButton = form.querySelector('.filter__clear');
        if (clearButton) {
            clearButton.addEventListener('click', clearFilter)
        }

        // form.querySelector('.filter__tags__tag--remove').addEventListener('click', (e) => {
        //     var url  = window.location.href.split('?');
        //     history.replaceState(null, null, url[0]);
        //     fetchFilteredView(new URLSearchParams(location.search));
        //     updateFilterInputs(inputs);
        // })
        updateSelectedValues();
    }

    function clearFilter(e) {
        e.preventDefault();
        form.querySelectorAll('input').forEach(input => {
            switch (input.type) {
                case 'text':
                case 'search':
                    input.value = '';
                    break;
                case 'radio':
                case 'checkbox':
                    input.checked = '';
                    break;
            }
        });
        history.replaceState(null, null, '?');
        fetchFilteredView(new URLSearchParams());
        updateFilterActiveState(new URLSearchParams());
    }

    function updateFilterActiveState(searchParams) {
        var toggle = form.querySelector('.toggle');
        if (!toggle) return;
        if (toggle.dataset.exclude) {
            searchParams.delete(toggle.dataset.exclude);
        }
        searchParams.delete('page');
        var toggleButton = form.querySelector('.filter__toggle')
        var toggleButtonText = toggleButton.querySelector('.filter__toggle__text');
        if (!(toggleButton || toggleButtonText)) return;
        var isActive = Array.from(searchParams).length > 0;
        form.dataset.isActive = isActive;
        if (isActive) {
            toggleButtonText.innerHTML = toggleButton.dataset.filterActiveText;
        }
        else {
            toggleButtonText.innerHTML = toggleButton.dataset.filterInactiveText;
        }
    }

    function initFilterInputs(inputs) {
        inputs.forEach(input => {
            switch (input.getAttribute('type')) {
                case 'hidden':
                    form.addEventListener('change', () => { handleHiddenField(input) });
                    break;
                case 'search':
                case 'text':
                    input.addEventListener('input', handleTextFieldUpdate);
                    break;
                case 'checkbox':
                case 'radio':
                    input.addEventListener('change', function () { handleCheckboxUpdate(input); });
                    break;
            }
            input.setAttribute('aria-controls', form.getAttribute('data-filter-for'));
        });
    }


    function handleHiddenField(input) {
        const searchParams = new URLSearchParams(window.location.search);
        searchParams.set(input.name, input.value);
        history.replaceState(null, null, `?${searchParams.toString()}`);
    }

    function updateFilterInputs(inputs) {
        const searchParams = new URLSearchParams(location.search);
        inputs.forEach(input => {
            const name = input.getAttribute('name');
            const value = searchParams.get(name);
            // if (searchParams.has(name)) {
            switch (input.getAttribute('type')) {
                case 'search':
                case 'text':
                    // case 'hidden':
                    input.value = value;
                    break;
                case 'radio':
                case 'checkbox':
                    updateCheckbox(input, value);
                    break;
            }
            // }
        });
        updateFilterActiveState(searchParams);
    }

    function updateCheckbox(input, values) {
        var checked;
        if (values) {
            values.split(',').forEach((value) => {
                if (value === input.value) {
                    checked = true;
                }
            });
        }
        else {
            const checkboxForDefault = form.querySelector(`input[data-clear="${input.name}"]`);
            if (checkboxForDefault) {
                checkboxForDefault.checked = true;
            }
        }
        input.checked = checked;

        var tagTitle = input.getAttribute('data-tag');
        var name = input.getAttribute('name');
        if (tagTitle) {
            checked ? addTag(tagTitle, name, input.value) : removeTag(name, input.value);
        }
    }

    function handleTextFieldUpdate(e) {
        const name = this.getAttribute('name');
        const value = this.value;
        // If enter, update without delay.
        if (e.keyCode === 13) {
            updateSearchParamsAndFetchResult(name, value);
            return;
        }
        clearTimeout(textFieldTimer);
        textFieldTimer = setTimeout(function () {
            updateSearchParamsAndFetchResult(name, value);
        }, 500);
    }

    function clearCheckboxGroup(checkbox) {
        const name = checkbox.dataset.clear;
        const checkboxes = form.querySelectorAll('input[name=' + name + ']');
        for (let i = 0; i < checkboxes.length; i++) {
            if (checkboxes[i].id == checkbox.id) {
                checkboxes[i].checked = true;
            }
            else {
                checkboxes[i].checked = false;
                removeTag(name, checkboxes[i].value);
            }
        }
        updateSearchParamsAndFetchResult(name, null);
    }

    function handleCheckboxUpdate(checkbox) {
        if (checkbox.dataset.clear) {
            clearCheckboxGroup(checkbox);
        }

        var tagTitle = checkbox.getAttribute('data-tag');
        if (tagTitle) {
            checkbox.checked ? addTag(tagTitle, name, checkbox.value) : removeTag(name, checkbox.value);
            var isMain = checkbox.getAttribute('data-isMain');
            if (isMain == "1") {
                var subId = checkbox.getAttribute('data-mapperMain');
                var subLocations = document.querySelectorAll(`[data-mapper="${subId}"]`);
                subLocations.forEach(function (node) {
                    if (checkbox.checked === true) {
                        node.checked = true;
                    } else {
                        node.checked = false;
                    }
                });
            }
            if (isMain == "0") {
                var mainId = checkbox.getAttribute('data-mapper');
                var mainLocation = document.querySelector(`[data-mapperMain="${mainId}"]`);
                var mainTagTitle = mainLocation.getAttribute('data-tag');
                var mainName = mainLocation.getAttribute('name');
                mainLocation.checked ? addTag(mainTagTitle, mainName, mainLocation.value) : removeTag(mainName, mainLocation.value);
                checkMainLocationCheck(mainLocation);
            }
        }

        const name = checkbox.getAttribute('name');
        const checkboxes = form.querySelectorAll('input[name=' + name + ']');
        let value = '';
        for (let i = 0; i < checkboxes.length; i++) {
            if (checkboxes[i].checked && checkboxes[i].dataset.clear !== name) {
                var isMainBool = checkboxes[i].getAttribute('data-isMain');
                if (isMainBool === "1") {

                } else {
                    value += `,${checkboxes[i].value}`;
                }
            }
        }
        if (value) value = value.substring(1);

        if (checkbox.getAttribute('data-filter-update')) {
            updateConnectedFilter(checkbox, value);
        }

        if (checkbox.getAttribute('type') == 'radio') {
            var searchParams = new URLSearchParams(window.location.search);
            var previous = searchParams.get(name);
            removeTag(name, previous);
        }

        updateSearchParamsAndFetchResult(name, value);

        const clearBox = form.querySelector(`input[data-clear="${name}"]`);
        if (clearBox) {

            clearBox.checked = !value;
        }

        updateSelectedValues();
    }

    function updateSelectedValues() {
        var areaCount = document.getElementById('area-counter');
        var typeCount = document.getElementById('type-counter');
        var sizeCount = document.getElementById('size-counter');

        if (areaCount == null || typeCount == null || sizeCount == null) {
            return;
        }

        var translate = sizeCount.getAttribute('data-translate');
        //Area 
        var areaTop = document.getElementsByClassName('premise-search-filter-area')[0];
        let areaCounter = 0;
        var subLocations = areaTop.querySelectorAll(`[data-counter="sub-location"]`);
        subLocations.forEach(function (node) {
            if (node.checked === true) {
                areaCounter++;
            }
        });
        if (areaCounter > 0) {
            areaCount.textContent = areaCounter + " " + translate;
            areaCount.classList.remove('hidden');

        } else {
            areaCount.textContent = "";
            areaCount.classList.add('hidden');
        }
        //Size
        var sizeTop = document.getElementsByClassName('premise-search-filter-size')[0];
        let sizeCounter = 0;
        var sizeInputs = sizeTop.querySelectorAll(`[data-counter="size"]`);
        sizeInputs.forEach(function (node) {
            if (node.checked === true) {
                sizeCounter++;
            }
        });
        if (sizeCounter > 0) {
            sizeCount.textContent = sizeCounter + " " + translate;
            sizeCount.classList.remove('hidden');

        } else {
            sizeCount.textContent = "";
            sizeCount.classList.add('hidden');
        }
        //Type
        var typeTop = document.getElementsByClassName('premise-search-filter-type')[0];
        let typeCounter = 0;
        var typeInputs = typeTop.querySelectorAll(`[data-counter="type"]`);
        typeInputs.forEach(function (node) {
            if (node.checked === true) {
                typeCounter++;
            }
        });
        if (typeCounter > 0) {
            typeCount.textContent = typeCounter + " " + translate;
            typeCount.classList.remove('hidden');

        } else {
            typeCount.textContent = "";
            typeCount.classList.add('hidden');
        }
    }

    function checkMainLocationCheck(mainLocation) {
        var subId = mainLocation.getAttribute('data-mapperMain');
        var subs = document.querySelectorAll(`[data-mapper="${subId}"]`);
        var checkMain = false;
        subs.forEach(function (node) {
            if (node.checked) {
                checkMain = true;
            }
        });
        if (checkMain === false) {
            mainLocation.checked = false;
        } else {
            mainLocation.checked = true;
        }
    }

    function updateSearchParamsAndFetchResult(name, value) {

        const searchParams = new URLSearchParams(window.location.search);
        searchParams.delete('page');
        searchParams.delete('pastpage');
        if (value) {
            searchParams.set(name, value);
        } else {
            searchParams.delete(name);
        }
        history.replaceState(null, null, `?${searchParams.toString()}`);
        fetchFilteredView(searchParams);
        updateFilterActiveState(searchParams);
    }

    function fetchFilteredView(searchParams) {
        window.dispatchEvent(new CustomEvent('FilterUpdate', { detail: searchParams }));
        resultContainer.setAttribute('data-loading', 'true');

        request.abort();

        const url = form.getAttribute('action') + form.getAttribute('data-filter-action') + '?' + searchParams.toString();

        request.onreadystatechange = function () {
            if (this.readyState !== 4) return;
            if (this.status === 500) {
                return;
            }
            if (this.status !== 200) return;
            updateView(this.responseText);
        };
        request.open('GET', url, true);
        request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        request.send();
    }

    function updateView(html) {
        setTimeout(() => {
            const temp = document.createElement('div');
            temp.innerHTML = html;
            const element = temp.querySelector('#' + resultContainer.id);
            element.classList.add('initializing');
            const container = document.getElementById(resultContainer.id);
            container.parentNode.replaceChild(element, container);
            const message = element.dataset.filterResultMessage;

            //Hack for map
            const mapElement = temp.querySelector('#PremisesMap');
            const previousMapElement = document.getElementById('PremisesMap');
            if (mapElement && previousMapElement) {
                previousMapElement.parentNode.replaceChild(mapElement, previousMapElement);
                loader.parseDom(mapElement);
            }

            if (message) {
                updateFilterMessage(message);
            }
            setTimeout(() => {
                element.classList.remove('initializing');
            }, 100);
            resultContainer = element;

            const countElement = document.querySelector('.filter__count');
            if (countElement) {
                countElement.innerHTML = `(${resultContainer.dataset.totalCount})`;
            }
            window.dispatchEvent(new CustomEvent('ResultUpdated', { detail: resultContainer.dataset.totalCount }));

            loader.parseDom(resultContainer);

        }, 150);
    }

    function updateFilterMessage(message) {
        var el = document.querySelector('.filter-result-message');
        if (el) {
            el.innerHTML = message;
        }
    }

    function updateConnectedFilter(input, value) {
        const connectedContainer = document.getElementById(input.getAttribute('data-filter-update'));
        const searchParams = new URLSearchParams(window.location.search);
        const inputs = connectedContainer.querySelectorAll('input');
        inputs.forEach(i => {
            const name = i.getAttribute('name');
            searchParams.delete(name);
            removeTag(name, input.value);
        });
        history.replaceState(null, null, `?${searchParams.toString()}`);

        if (value === '') {
            connectedContainer.classList.add('hidden');
            connectedContainer.innerHTML = '';
            return;
        }

        const url = input.getAttribute('data-fetch-url');
        const updateFilterRequest = new XMLHttpRequest();
        updateFilterRequest.onreadystatechange = function () {
            if (this.readyState !== 4) return;
            if (this.status === 500) {
                console.log('error', this);
                return;
            }
            if (this.status !== 200) return;
            connectedContainer.innerHTML = this.responseText;
            connectedContainer.classList.remove('hidden');
            const containerInputs = connectedContainer.querySelectorAll('input');

            initFilterInputs(containerInputs);
            updateFilterInputs(containerInputs);
        };
        updateFilterRequest.open('POST', url, true);
        updateFilterRequest.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        updateFilterRequest.setRequestHeader('Content-Type', 'application/json');
        updateFilterRequest.send(JSON.stringify({ value }));
    }

    function addTag(title, name, value) {
        var container = form.querySelector('.filter__tags');
        if (!container) return;
        var tag = document.createElement('span');
        tag.classList.add('filter__tags__tag');
        tag.setAttribute('data-value', value);
        tag.setAttribute('data-name', name);
        tag.innerHTML = title + " " + new Icon('cross').render();
        tag.addEventListener('click', (e) => {

            var searchParams = new URLSearchParams(window.location.search);
            searchParams.delete('page');

            var param = searchParams.get(name)
            if (param) {
                let params = param.split(',');
                var nextParam = "";
                params.forEach((val) => {
                    if (val != value) nextParam += ',' + val;
                });
                if (nextParam) {
                    searchParams.set(name, nextParam.substring(1));
                }
                else {
                    searchParams.delete(name);
                }
            }

            var inputs = form.querySelectorAll(`input[name="${name}"][value="${value}"]`);

            if (inputs[0].getAttribute('data-filter-update')) {
                var connectedContainer = document.getElementById(inputs[0].getAttribute('data-filter-update'));
                var connectedInputs = connectedContainer.querySelectorAll('input');
                connectedInputs.forEach(input => {
                    var name = input.getAttribute('name');
                    searchParams.delete(name);
                    removeTag(name, input.value);
                });
                connectedContainer.parentNode.parentNode.classList.add('hidden');
            }

            history.replaceState(null, null, '?' + searchParams.toString());
            fetchFilteredView(searchParams);

            updateFilterInputs(inputs);

            tag.remove();
        })
        container.insertAdjacentElement('afterbegin', tag);
    }

    function removeTag(name, value) {
        form.querySelectorAll('.filter__tags__tag').forEach((tag) => {
            if (tag.getAttribute('data-value') == value && tag.getAttribute('data-name') == name) {
                tag.remove();
            }
        });
    }

    return {
        init: init
    }
}

loader.add('Filter', Filter);

export default Filter;